// eslint-disable-next-line import/prefer-default-export
export const RESPONSIVE_ACTION_LIST_LAYOUT_BREAKPOINT = 1392
